import { ActionIcon, Button } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { IconAdjustments } from '@tabler/icons-react';

import { useChartContext } from '@/contexts/ChartContext';

import ConfigDrawer from './ConfigDrawer';

export function ConfigureChartButton() {
  const [drawerOpened, { open: openDrawer, close: closeDrawer }] = useDisclosure(false);
  const { chartData } = useChartContext();

  return (
    <>
      <ActionIcon
        variant="subtle"
        color="gray"
        size="lg"
        onClick={openDrawer}
        aria-label="Configure chart"
        hiddenFrom="sm"
      >
        <IconAdjustments size={18} />
      </ActionIcon>
      <Button
        variant="subtle"
        color="gray"
        size="compact-sm"
        onClick={openDrawer}
        leftSection={<IconAdjustments size={16} />}
        visibleFrom="sm"
      >
        Configure
      </Button>
      <ConfigDrawer opened={drawerOpened} onClose={closeDrawer} chartData={chartData} />
    </>
  );
}
